import React from "react"
import { X, CheckCircle, XCircle, AlertTriangle, Info } from "lucide-react"
import { useUIStore } from "@/stores/uiStore"

export const NotificationSystem: React.FC = () => {
	const { notifications, removeNotification } = useUIStore()

	if (notifications.length === 0) {
		return null
	}

	return (
		<div className='fixed top-4 right-4 z-50 space-y-2'>
			{notifications.map((notification) => {
				const Icon = {
					success: CheckCircle,
					error: XCircle,
					warning: AlertTriangle,
					info: Info,
				}[notification.type]

				const colors = {
					success: "bg-green-50 border-green-200 text-green-800",
					error: "bg-red-50 border-red-200 text-red-800",
					warning: "bg-yellow-50 border-yellow-200 text-yellow-800",
					info: "bg-primary/10 border-primary/20 text-primary-dark",
				}

				const iconColors = {
					success: "text-green-400",
					error: "text-red-400",
					warning: "text-yellow-400",
					info: "text-primary",
				}

				return (
					<div key={notification.id} className={`max-w-sm p-4 rounded-lg border shadow-lg ${colors[notification.type]} transition-all duration-300 transform`}>
						<div className='flex items-start'>
							<Icon className={`w-5 h-5 mt-0.5 ${iconColors[notification.type]}`} />
							<div className='ml-3 flex-1'>
								<h4 className='text-sm font-medium'>{notification.title}</h4>
								<p className='text-sm mt-1'>{notification.message}</p>
							</div>
							<button onClick={() => removeNotification(notification.id)} className='ml-4 inline-flex text-gray-400 hover:text-gray-600'>
								<X className='w-4 h-4' />
							</button>
						</div>
					</div>
				)
			})}
		</div>
	)
}
